import { IconDefinition } from "@fortawesome/pro-duotone-svg-icons";
import { createContext, useContext, useState } from "react";

export interface IBreadcrumb {
  label: React.ReactNode;
  icon?: IconDefinition;
  to: string;
}

interface IBreadcrumbContext {
  breadcrumbs: IBreadcrumb[];
  setBreadcrumbs: (b: IBreadcrumb[]) => void;
}

const BreadcrumbContext = createContext<IBreadcrumbContext | null>(null);

export const BreadcrumbProvider = ({ children }: { children: React.ReactNode; }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>([]);
  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) throw new Error("useBreadcrumbs must be used inside BreadcrumbProvider");
  return ctx;
};
